<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <core-table title="Customers" upsert-max-width="850px" :config="config">
          <template slot='headerActions'>
            <slot name='headerActions' />
          </template>
        </core-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import { get, post } from '@/api/base_entity'

export default {
  data() {
    return {
      config,
      protocol_id: null,
      site_id: null,
      loadingExport: false,
      counters: {}
    }
  },
  async created() {
  },
  mounted() {
    this.loadCounters()
  },
  methods: {
    async sync(platform) {

      const ret = await this.$root.$confirm.open('Confirm Sync Platform', 'Are you sure you want to sync the countries for platform ' + platform + ' ?', { color: 'red' })
      if (!ret) {
        return
      }

      this.counters[platform] = '...'

      post('/sync_platforms/country', { platform }).then(() => {
        this.$root.$emit('openSnackbar', {
          message: platform + ' synced correctly',
          color: 'success'
        })
      }).finally(() => {
        this.loadCounters()
      })

    },
    loadCounters() {
      get('/country_counters').then(ret => {
        this.counters = ret
      })
    },
  }
}
</script>
